import { useRef, useState } from "react";

// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormLabel,
  Grid,
  Typography,
  Paper,
  ButtonBase,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardContent,
  FormGroup,
  OutlinedInput,
  CircularProgress,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";

import {
  ExpandMore as ExpandMoreIcon,
  CloudUpload as CloudUploadIcon,
} from "@material-ui/icons";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Snackbar from "components/Alerts/Snackbar";
import UtilsFncs from "utils/UtilsFncs";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import componentStylesDialog from "assets/theme/components/dialog";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles({
  paper: { overflow: "hidden" },
});
const useStylesDialog = makeStyles(componentStylesDialog);

const CheckboxOption = withStyles(() => ({
  label: {
    fontSize: "1rem",
  },
  root: {
    marginBottom: 0,
  },
}))(FormControlLabel);

const DetailItem = ({ label, value, isMobile }) => {
  const valueToRender = value?.toString() || "";

  return (
    <Grid
      item
      xs={isMobile ? 12 : 4}
      style={{ marginBottom: "1rem", display: "flex", flexDirection: "column" }}
    >
      <FormLabel style={{ textTransform: "uppercase", marginBottom: "0.5rem" }}>
        {label.toLowerCase()}
      </FormLabel>
      <TextField
        type="text"
        variant="outlined"
        value={valueToRender.trim().length > 0 ? valueToRender : "-"}
      />
    </Grid>
  );
};

const DataExchange = ({ label, value }) => {
  return (
    <Typography
      gutterBottom
      variant="subtitle2"
      style={{ fontSize: "13px", marginBottom: "0.4rem" }}
    >
      <span style={{ fontWeight: "600" }}>{label?.toUpperCase()}</span> {value}
    </Typography>
  );
};

const DialogTrocaDevolucaoDetalhePedido = ({
  idDevolucao,
  pedido,
  onClose,
}) => {
  const snackbar = useSnackbar();
  const detailsRef = useRef(null);
  const classes = { ...useStyles(), ...useStylesDialog() };

  const [expanded, setExpanded] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileBase64, setSelectedFileBase64] = useState(null);
  const [uploadingXML, setUploadingXML] = useState(null);

  const [msgSucesso, setMsgSucesso] = useState("");
  const [openSucesso, setOpenSucesso] = useState(false);
  const [msgErro, setMsgErro] = useState("");
  const [openErro, setOpenErro] = useState(false);

  const [disableExchange, setDisableExchange] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const isMobile = IsMobile();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleCloseErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenErro(false);
  };

  const handleCloseSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSucesso(false);
  };

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    if (event.target.files[0] instanceof Blob) {
      UtilsFncs.FileToB64(event.target.files[0])
        .then((file) => {
          setSelectedFileBase64(file);
        })
        .catch((error) => {
          console.log("Error: " + error);
        });
    } else {
      setSelectedFileBase64(null);
      document.getElementById("uploadXML_").value = null;
    }
  };

  async function upLoadXML() {
    const formData = new FormData();

    const encodedBase64 = selectedFileBase64
      ?.toString()
      ?.replace(/^data:(.*,)?/, "");

    formData.append("base64Xml", encodedBase64);
    formData.append("idPessoaLoja", pedido?.IdPessoaLoja);
    formData.append("idTrocaDevolucao", pedido?.IdTrocaDevolucao);

    const object = {};
    formData?.forEach(function (value, key) {
      object[key] = value;
    });

    setUploadingXML(pedido.IdAtendimentoApp);

    await Api.put("import-xml-change-product", "trocas", object, true)
      .then((value) => {
        if (value?.Success) {
          setMsgSucesso("XML de NF Troca/Devolução Enviado com sucesso.");
          setOpenSucesso(true);
          onClose({ idTrocaDevolucao: idDevolucao });
        }
      })
      .catch((error) => {
        setMsgErro(error);
        setOpenErro(true);
        console.log(error);
        document.getElementById("uploadXML_").value = null;      })
      .finally(() => {
        setUploadingXML(null);
        setSelectedFile(null);
        setSelectedFileBase64(null);
      });
  }

  const handleDisableExchange = async () => {
    setSubmitting(true);

    await Api.put(
      "edit-order-change-product",
      "trocas",
      {
        idTrocaDevolucao: idDevolucao,
        ativo: false,
        itens: [],
      },
      true
    )
      .then((res) => {
        if (res?.Success) {
          snackbar.showMessage("Troca/Devolução desativada com sucesso!", {
            severity: "success",
          });
          onClose({ refresh: true });
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Dialog
      open={Boolean(pedido)}
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      classes={{ paper: classes.paper }}
      maxWidth="lg"
    >
      <div className={classes.dialogHeader}>
        <Typography variant="h5" component="h5" className={classes.dialogTitle}>
          Detalhe da Solicitação
        </Typography>
      </div>

      <DialogContent
        ref={detailsRef}
        style={{
          paddingRight: "0px",
          marginRight: "1.5rem",
          overflowX: "hidden",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <DetailItem
              key={pedido?.NomeLoja}
              label={"Loja"}
              value={pedido?.NomeLoja}
              isMobile={isMobile}
            />
            <DetailItem
              key={pedido?.NomeConsumidor}
              label={"Nome do Consumidor"}
              value={pedido?.NomeConsumidor}
              isMobile={isMobile}
            />
            <DetailItem
              key={pedido?.CpfConsumidor}
              label={"CPF Consumidor"}
              value={MaskAndValid.maskCPNJCPF(pedido?.CpfConsumidor)}
              isMobile={isMobile}
            />
          </Grid>
          <Grid item xs={12}>
            <Accordion
              onChange={handleChange(pedido?.IdTrocaDevolucao)}
              expanded={
                expanded === pedido?.IdTrocaDevolucao &&
                pedido?.ListDevolucaoTroca?.length !== 0
              }
            >
              <Grid item xs={12}>
                <AccordionSummary
                  expandIcon={
                    pedido?.ListDevolucaoTroca?.length !== 0 && (
                      <ExpandMoreIcon />
                    )
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    border: "1px solid #d3d3d3",
                    borderRadius: "5px",
                  }}
                >
                  <div
                    role="presentation"
                    style={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                    }}
                  >
                    {pedido?.NumeroNF !== "" ? (
                      <Typography
                        style={{
                          fontWeight: "bold",
                          fontSize: isMobile ? "0.8rem" : "1rem",
                          marginBottom: isMobile ? "0.5rem" : 0,
                        }}
                      >
                        Número da Nota: {pedido?.NumeroNF}
                      </Typography>
                    ) : (
                      <Typography
                        style={{
                          fontWeight: "bold",
                          fontSize: isMobile ? "0.8rem" : "1rem",
                          marginBottom: isMobile ? "0.5rem" : 0,
                        }}
                      >
                        Número da Troca: {pedido?.IdTrocaDevolucao}
                      </Typography>
                    )}
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: isMobile ? "0.8rem" : "1rem",
                        marginLeft: isMobile ? 0 : "3rem",
                      }}
                    >
                      Data inclusão: {pedido?.DataInclusaoFormat}
                    </Typography>
                  </div>
                </AccordionSummary>
              </Grid>
              {pedido?.ListDevolucaoTroca?.map((itemAtendimento, index) => {
                return (
                  <AccordionDetails
                    key={index}
                    style={{
                      padding: 0,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <CardContent>
                      <Grid container>
                        <Grid item xs={12}>
                          <Paper key={index} className={classes.paper}>
                            <Typography
                              variant="h5"
                              component="h5"
                              className={classes.dialogTitle}
                              style={{ margin: "1rem 0 0 1rem" }}
                            >
                              Pedido {itemAtendimento?.IdPedido}
                            </Typography>
                            <Grid
                              container
                              spacing={1}
                              style={{
                                padding: "1rem",
                                flexDirection: isMobile ? "column" : "row",
                              }}
                            >
                              <Grid item>
                                <ButtonBase className={classes.image}>
                                  <ImagePlaceholder
                                    className={classes.img}
                                    alt="Imagem do item do atendimento"
                                    src={itemAtendimento?.Foto}
                                    width={85}
                                    widthOnError={40}
                                    imagePreviewTitle={`Item ${itemAtendimento?.IdProduto}`}
                                  />
                                </ButtonBase>
                              </Grid>
                              <Grid item xs={isMobile ? 12 : 6} sm container>
                                <Grid item xs={12} display="flex">
                                  <DataExchange
                                    value={itemAtendimento?.DescricaoProduto}
                                  />
                                </Grid>
                              </Grid>
                              <Grid item xs={12} sm container>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: isMobile
                                      ? "space-between"
                                      : "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div>
                                    <DataExchange
                                      label="Número do Item na Troca : "
                                      value={`${itemAtendimento?.IdTrocaDevolucaoItem}`}
                                    />
                                    <DataExchange
                                      label="Código do Produto : "
                                      value={`${itemAtendimento?.IdProduto}`}
                                    />
                                  </div>
                                  <div>
                                    <DataExchange
                                      label="Tipo de Solicitação : "
                                      value={`${
                                        itemAtendimento?.TipoSolicitacao ===
                                        "DEVOLUCAO"
                                          ? " Devolução"
                                          : " Troca "
                                      }`}
                                    />
                                    <DataExchange
                                      label={`Quantidade ${
                                        itemAtendimento?.TipoSolicitacao ===
                                        "DEVOLUCAO"
                                          ? " Devolução "
                                          : " Troca "
                                      } : `}
                                      value={`${itemAtendimento?.QuantidadeTroca}`}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </AccordionDetails>
                );
              })}
            </Accordion>
            <Grid
              item
              xs={isMobile ? 12 : 4}
              style={{ marginTop: "2rem" }}
              hidden={pedido?.ListDevolucaoTroca?.length !== 0}
            >
              <CheckboxOption
                control={
                  <Checkbox
                    size="small"
                    color="primary"
                    onClick={() => setDisableExchange(!disableExchange)}
                    checked={disableExchange}
                  />
                }
                label="Desativar troca/devolução"
              />
            </Grid>
            <Grid
              item
              xs={isMobile ? 12 : 4}
              style={{ marginTop: "2rem" }}
              hidden={
                pedido?.NumeroNF !== "" ||
                pedido?.ListDevolucaoTroca?.length === 0
              }
            >
              <Box textAlign="left">
                <FormGroup width="fit-content">
                  <FormLabel
                    style={{
                      textTransform: "uppercase",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Enviar XML
                  </FormLabel>
                  <OutlinedInput
                    id="uploadXML_"
                    fullWidth
                    type="file"
                    placeholder="Default input"
                    onChange={changeHandler}
                    disabled={uploadingXML === pedido.IdAtendimentoApp}
                    accept=".xml"
                    endAdornment={
                      selectedFile &&
                      uploadingXML === pedido.IdAtendimentoApp ? (
                        <InputAdornment position="end">
                          <CircularProgress
                            style={{ marginLeft: 5, marginBottom: 1 }}
                            size={16}
                          />
                        </InputAdornment>
                      ) : (
                        ""
                      )
                    }
                  />
                </FormGroup>
              </Box>
              {selectedFile ? (
                <Button
                  disabled={uploadingXML === pedido.IdAtendimentoApp}
                  variant="contained"
                  color="default"
                  className={classes.button}
                  endIcon={<CloudUploadIcon />}
                  onClick={upLoadXML}
                >
                  Enviar XML
                </Button>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button component={Box} onClick={onClose}>
          Fechar
        </Button>
        {disableExchange && (
          <Button
            component={Box}
            onClick={handleDisableExchange}
            color="default"
            variant="contained"
            disabled={submitting}
          >
            {submitting ? "Desativando troca/devolução..." : "Desativar"}
            {submitting ? (
              <CircularProgress style={{ marginLeft: 5 }} size={16} />
            ) : null}
          </Button>
        )}
      </DialogActions>
      <Snackbar
        text={msgSucesso}
        open={openSucesso}
        autoHideDuration={6000}
        onClose={handleCloseSucesso}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity="success"
      />
      <Snackbar
        text={msgErro}
        open={openErro}
        autoHideDuration={6000}
        onClose={handleCloseErro}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity="error"
      />
    </Dialog>
  );
};

export default DialogTrocaDevolucaoDetalhePedido;
